import React from 'react';
import Router from './src/router/Router';
import { Provider as PaperProvider } from 'react-native-paper';
import SnackBarNetwork from './src/components/feedbacks/snackBar/snackBarNetwork';
import * as Sentry from 'sentry-expo';
import AppContextProvider from './src/providers/AppContextProvider';
// @ts-ignore
import { stopReportingRuntimeErrors } from "react-error-overlay";
import {Platform} from "react-native";

if (process.env.NODE_ENV === "development" && Platform.OS === "web") {
    stopReportingRuntimeErrors(); // disables error overlays
}


Sentry.init({
  dsn: 'https://0e1fdeb7d33342f39a1333ae7ab8c3a0@o428126.ingest.sentry.io/5437671',
  enableInExpoDevelopment: true,
  debug: true,
});

export default function App() {
  return (
      <PaperProvider>
        <AppContextProvider>
          <>
            <SnackBarNetwork />
            <Router />
          </>
        </AppContextProvider>
      </PaperProvider>
  );
}

